// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.working-hours-widget .working-hours-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.working-hours-widget .time {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}
.working-hours-widget .time .startTime div, .working-hours-widget .time .endTime div {
  font-size: clamp(13px, 1.5vw, 15px);
  color: #888;
}
.working-hours-widget .time .startTime span, .working-hours-widget .time .endTime span {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: clamp(13px, 2.5vw, 22px);
  font-weight: 600;
}
.working-hours-widget .time .startTime span ion-icon, .working-hours-widget .time .endTime span ion-icon {
  color: #ed143d;
  font-size: 15px;
}
.working-hours-widget .days {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.working-hours-widget .days span {
  font-size: clamp(12px, 2.5vw, 20px);
  margin-inline: 3px;
  font-weight: 600;
}
.working-hours-widget .days span.active {
  color: #ed143d;
}

ion-spinner {
  margin: 0 auto;
  height: 8px;
}

@media (min-width: 768px) {
  .working-hours-widget .working-hours-container .days span {
    font-size: clamp(12px, 1.5vw, 16px);
  }
  .time .startTime div, .time .endTime div {
    font-size: clamp(13px, 1vw, 15px) !important;
  }
  .time .startTime span, .time .endTime span {
    font-size: clamp(13px, 1.5vw, 15px) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/working-hours-widget/working-hours-widget.component.scss"],"names":[],"mappings":"AAKI;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;AAJR;AAMI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAJR;AAMY;EACI,mCAAA;EAEA,WAAA;AALhB;AAOY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,gBAAA;AALhB;AAMgB;EACI,cAAA;EACA,eAAA;AAJpB;AASI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAPR;AAQQ;EACI,mCAAA;EACA,kBAAA;EACA,gBAAA;AANZ;AAOY;EACI,cAAA;AALhB;;AAWA;EACI,cAAA;EACA,WAAA;AARJ;;AAWA;EAIgB;IACI,mCAAA;EAXlB;EAkBU;IACI,4CAAA;EAhBd;EAkBU;IACI,8CAAA;EAhBd;AACF","sourcesContent":["  \n\n.working-hours-widget {\n\n\n    .working-hours-container {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        min-height: 0;\n    }\n    .time {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 5px;\n        .startTime, .endTime {\n            div {\n                font-size: clamp(13px, 1.5vw, 15px);\n\n                color: #888;\n            }\n            span {\n                display: flex;\n                align-items: center;\n                gap: 5px;\n                font-size: clamp(13px, 2.5vw, 22px);\n                font-weight: 600;\n                ion-icon {\n                    color: #ed143d;\n                    font-size: 15px;\n                }\n            }\n        }\n    }\n    .days {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        justify-content: center;\n        span {\n            font-size: clamp(12px, 2.5vw, 20px);\n            margin-inline: 3px;\n            font-weight: 600;\n            &.active {\n                color: #ed143d;\n            }\n        }\n    }\n}\n\nion-spinner {\n    margin: 0 auto;\n    height: 8px;\n}\n\n@media (min-width: 768px) {\n    .working-hours-widget {\n        .working-hours-container {\n            .days {\n                span {\n                    font-size: clamp(12px, 1.5vw, 16px);\n                }\n            }\n        }\n    }\n    .time {\n        .startTime, .endTime {\n            div {\n                font-size: clamp(13px, 1vw, 15px) !important;\n            }\n            span {\n                font-size: clamp(13px, 1.5vw, 15px) !important;\n            }\n        }\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
